import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { User } from "../domain/user";
import { Permissions } from "../domain/user-profile/permissions";
import { CoreData } from "../tools/core-data/core-data";
import { BaseService } from "./base.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoadingTask } from "../tools/loading-task";
import { mapper } from "../tools/mapping/mapper";
import { UserDTO } from "./dto/user.dto";
import { Appareil } from "../domain/Qualif/appareil";

@Injectable({
    providedIn: 'root',
})
export class UserService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/user`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getRolePermissions() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/Role`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getRoles')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Permissions[]) => {
                return response.map((item: Permissions) => {
                    return Permissions.mapFromJSON(item);
                });
            }));
    }

    getUserByEmail(email: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${email}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getuserByEmail')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: UserDTO) => {
                return mapper.map(response, UserDTO, User);
            }));
    }

    updateAppareilList(email: string, appareils: Appareil[]) {
        this.loadingTask.activateLoading();
        const dto = JSON.stringify(appareils);
        return this.http.post(`${this.serviceUrl}/${email}/Appareils`, dto, this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateAppareilList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}